class Product {
  id = null;
  code = null;
  type = null;
  name = null;
  description = null;
  status = null;
  revenueRecognition = null;
  crmProductGroupCode = null;
  responsibleCenterCode = null;
  categoryIds = [];
  skuItems = [];

  constructor(data) {
    this.id = data.id ?? null;
    this.code = data.code ?? null;
    this.name = data.name ?? null;
    this.description = data.description ?? null;
    this.status = data.status ?? null;
    this.type = data.type ?? null;
    this.revenueRecognition = data.revenueRecognition ?? null;
    this.crmProductGroupCode = data.crmProductGroupCode ?? null;
    this.responsibleCenterCode = data.responsibleCenterCode ?? null;
    this.categoryIds = data.categoryIds ?? [];
    this.skuItems = data.skuItems ?? [];
  }
}

export default Product;